import { useSyncExternalStore } from 'react'

const subscribe = () => () => undefined

export function useIsHydrated() {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  )
}
